// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"PageWrapper--1TLsQ","RangePicker":"RangePicker--OPsu1","Title":"Title--3FJYk","Table":"Table--1tB6S","TableEntry":"TableEntry--1swt_"};